import { CommonInput, FlexBox, INPUT_TYPES, MagicBoxRow, useBreakpoint } from "@brg/ui";
import { BaseSyntheticEvent, ChangeEvent, forwardRef, useRef } from "react";
import { TdInputContainer } from "../../styles";
import { Switcher } from "./Switcher";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import { DottedIcon } from "shared/icons/DottedIcon";
import { SortableKnob } from "react-easy-sort";
import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { FormFieldType } from "../../constants";
import { Lang } from "@brg/api/dist/api-core/api/lang/LangProcessor";
import { useTranslation } from "react-i18next";
import { ModalInput } from "./ModalInput";
import {ReactComponent as DeleteIcon} from "../../assets/delete.svg";
import { LayoutConst } from "core";

interface TdInputProps {
  type: FormFieldType;
  placeholder: LangObjectArray;
  isDisabled: boolean;
  header: LangObjectArray;
  isRequired?: boolean;
  index: number;
  onToggleModalClick: (index: number) => void;
  onChange: (id: any,ev: BaseSyntheticEvent, lang?: string) => void;
  onDeleteField: (id: number) => void;
  onSwitchChange: (id: number, value: number | boolean) => void;
  onRequiredChange: (id: number, value: boolean) => void;
}

export const TdInput = forwardRef<HTMLTableRowElement, TdInputProps>(({
  type,
  index,
  placeholder,
  isDisabled,
  header,
  isRequired,
  onChange,
  onToggleModalClick,
  onDeleteField,
  onSwitchChange,
  onRequiredChange
}, ref) => {
  const switcherRef = useRef<any>(null);
  const { t, i18n } = useTranslation();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

  const fieldTypes = Object
    .keys(FormFieldType)
    .filter(key => {
      if (key === 'LegalDocument') return false;
      return isNaN(Number(key))
    })
    .map(k => ({
      label: t(`applicationEditor.sections.fields.${k}`),
      value: FormFieldType[k as keyof typeof FormFieldType]
    }));

    if (isMobile) {
      return (
        <TdInputContainer ref={ref}>
          <FlexBox justify="space-between">
            <SortableKnob >
              <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                  <DottedIcon />
              </div>
            </SortableKnob>
            <FlexBox style={{ gap: 24}}>
              <Switcher
                ref={switcherRef}
                value={isDisabled ? 0 : 1}
                label=""
                onChange={(value: any) => onSwitchChange(index, value)}
              />
              <div onClick={() => onDeleteField(index)}>
                <DeleteIcon />
              </div>
            </FlexBox>
          </FlexBox>
          <FlexBox direction="column" align="flex-start" style={{ gap: 16}}>
            <CommonInput
              type={INPUT_TYPES.text}
              label={t('teams.adminPage.fields.form_field_name')}
              // placeholder={Lang(placeholder, i18n.language)}
              value={header}
              name={'header'}
              onWhiteBG
              useLangSwitcher
              switcherPosition="inside"
              onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
            />
              <ModalInput
                type={type}
                value={fieldTypes?.find((option) => option.value === type)?.label as string}
                options={fieldTypes}
                index={index} 
                onToggleModalClick={onToggleModalClick}
                onChange={onChange}
              />
              <FlexBox direction="column" align="center">
                <MagicBoxRow
                checked={isRequired || false}
                label={t('teams.adminPage.fields.form_field_required')}
                onClick={(ev: any) => onRequiredChange(index, !isRequired)} 
              />
            </FlexBox>
          </FlexBox>
        </TdInputContainer>
      )
    }

  return (
    <TdInputContainer ref={ref}>
      <td style={{padding: 0}}>
      <SortableKnob >
          <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
              <DottedIcon />
          </div>
      </SortableKnob>
      </td>
      <td>
    
      <CommonInput
        type={INPUT_TYPES.text}
        // label={label}
        // placeholder={Lang(placeholder, i18n.language)}
        value={header}
        name={'header'}
        onWhiteBG
        useLangSwitcher
        switcherPosition="inside"
        onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
      />
      </td>
      <td>
        <ModalInput
          type={type}
          value={fieldTypes?.find((option) => option.value === type)?.label as string}
          options={fieldTypes}
          index={index} 
          onToggleModalClick={onToggleModalClick}
          onChange={onChange}
        />
      </td>
     <td style={{padding: 0, width: '140px', textAlign: 'center'}}>
      <FlexBox direction="column" align="center">
        <MagicBoxRow
        checked={isRequired || false}
        label=""
        onClick={(ev: any) => onRequiredChange(index, !isRequired)} 
      />
      </FlexBox>
     </td>

      <td style={{padding: 0}}>
      <Switcher
        ref={switcherRef}
        value={isDisabled ? 0 : 1}
        label=""
        onChange={(value: any) => onSwitchChange(index, value)}
      />
     
      </td>
      <td style={{padding: 0, cursor: 'pointer'}}>
        <div onClick={() => onDeleteField(index)}>
          <DeleteIcon />
        </div>
        {/* <BasketIcon
          fill={'#838382'}
          onClick={() => onDeleteField(index)}
        /> */}
      </td>
    </TdInputContainer>
  );
});

TdInput.displayName = "TdInput";import { CommonInput, FlexBox, INPUT_TYPES, MagicBoxRow, useBreakpoint } from "@brg/ui";
import { BaseSyntheticEvent, ChangeEvent, forwardRef, useRef } from "react";
import { TdInputContainer } from "../../styles";
import { Switcher } from "./Switcher";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import { DottedIcon } from "shared/icons/DottedIcon";
import { SortableKnob } from "react-easy-sort";
import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { FormFieldType } from "../../constants";
import { Lang } from "@brg/api/dist/api-core/api/lang/LangProcessor";
import { useTranslation } from "react-i18next";
import { ModalInput } from "./ModalInput";
import {ReactComponent as DeleteIcon} from "../../assets/delete.svg";
import { LayoutConst } from "core";

interface TdInputProps {
  type: FormFieldType;
  placeholder: LangObjectArray;
  isDisabled: boolean;
  header: LangObjectArray;
  isRequired?: boolean;
  index: number;
  onToggleModalClick: (index: number) => void;
  onChange: (id: any,ev: BaseSyntheticEvent, lang?: string) => void;
  onDeleteField: (id: number) => void;
  onSwitchChange: (id: number, value: number | boolean) => void;
  onRequiredChange: (id: number, value: boolean) => void;
}

export const TdInput = forwardRef<HTMLTableRowElement, TdInputProps>(({
  type,
  index,
  placeholder,
  isDisabled,
  header,
  isRequired,
  onChange,
  onToggleModalClick,
  onDeleteField,
  onSwitchChange,
  onRequiredChange
}, ref) => {
  const switcherRef = useRef<any>(null);
  const { t, i18n } = useTranslation();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

  const fieldTypes = Object
    .keys(FormFieldType)
    .filter(key => {
      if (key === 'LegalDocument') return false;
      return isNaN(Number(key))
    })
    .map(k => ({
      label: t(`applicationEditor.sections.fields.${k}`),
      value: FormFieldType[k as keyof typeof FormFieldType]
    }));

    if (isMobile) {
      return (
        <TdInputContainer ref={ref}>
          <FlexBox justify="space-between">
            <SortableKnob >
              <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                  <DottedIcon />
              </div>
            </SortableKnob>
            <FlexBox style={{ gap: 24}}>
              <Switcher
                ref={switcherRef}
                value={isDisabled ? 0 : 1}
                label=""
                onChange={(value: any) => onSwitchChange(index, value)}
              />
              <div onClick={() => onDeleteField(index)}>
                <DeleteIcon />
              </div>
            </FlexBox>
          </FlexBox>
          <FlexBox direction="column" align="flex-start" style={{ gap: 16}}>
            <CommonInput
              type={INPUT_TYPES.text}
              label={t('teams.adminPage.fields.form_field_name')}
              // placeholder={Lang(placeholder, i18n.language)}
              value={header}
              name={'header'}
              onWhiteBG
              useLangSwitcher
              switcherPosition="inside"
              onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
            />
              <ModalInput
                type={type}
                value={fieldTypes?.find((option) => option.value === type)?.label as string}
                options={fieldTypes}
                index={index} 
                onToggleModalClick={onToggleModalClick}
                onChange={onChange}
              />
              <FlexBox direction="column" align="center">
                <MagicBoxRow
                checked={isRequired || false}
                label={t('teams.adminPage.fields.form_field_required')}
                onClick={(ev: any) => onRequiredChange(index, !isRequired)} 
              />
            </FlexBox>
          </FlexBox>
        </TdInputContainer>
      )
    }

  return (
    <TdInputContainer ref={ref}>
      <td style={{padding: 0}}>
      <SortableKnob >
          <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
              <DottedIcon />
          </div>
      </SortableKnob>
      </td>
      <td>
    
      <CommonInput
        type={INPUT_TYPES.text}
        // label={label}
        // placeholder={Lang(placeholder, i18n.language)}
        value={header}
        name={'header'}
        onWhiteBG
        useLangSwitcher
        switcherPosition="inside"
        onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
      />
      </td>
      <td>
        <ModalInput
          type={type}
          value={fieldTypes?.find((option) => option.value === type)?.label as string}
          options={fieldTypes}
          index={index} 
          onToggleModalClick={onToggleModalClick}
          onChange={onChange}
        />
      </td>
     <td style={{padding: 0, width: '140px', textAlign: 'center'}}>
      <FlexBox direction="column" align="center">
        <MagicBoxRow
        checked={isRequired || false}
        label=""
        onClick={(ev: any) => onRequiredChange(index, !isRequired)} 
      />
      </FlexBox>
     </td>

      <td style={{padding: 0}}>
      <Switcher
        ref={switcherRef}
        value={isDisabled ? 0 : 1}
        label=""
        onChange={(value: any) => onSwitchChange(index, value)}
      />
     
      </td>
      <td style={{padding: 0, cursor: 'pointer'}}>
        <div onClick={() => onDeleteField(index)}>
          <DeleteIcon />
        </div>
        {/* <BasketIcon
          fill={'#838382'}
          onClick={() => onDeleteField(index)}
        /> */}
      </td>
    </TdInputContainer>
  );
});

TdInput.displayName = "TdInput";